import {
  BufferTrackerReact as BufferTracker,
  Client,
} from '@buffer-mono/tracking-plan'

import type { HelpWidgetAccount } from './types'

function getEventData(
  account: HelpWidgetAccount | null,
): BufferTracker.BrainfishWidgetOpened | null {
  const organizationId = account?.currentOrganization?.id
  if (!organizationId || account?.isImpersonation) {
    return null
  }

  return {
    ...account?.currentOrganization?.commonTrackingProperties,
    clientName: Client.PublishWeb,
    organizationId,
    currentUrl: window.location.href,
  }
}

export function trackBrainfishOpened(account: HelpWidgetAccount | null): void {
  const eventData = getEventData(account)
  if (eventData) {
    BufferTracker.brainfishWidgetOpened(eventData)
  }
}

export function trackBrainfishClosed(account: HelpWidgetAccount | null): void {
  const eventData = getEventData(account)
  if (eventData) {
    BufferTracker.brainfishWidgetClosed(eventData)
  }
}
